import { allExercises } from '../vuex/exercises/getters'
import { getAllExercises } from '../vuex/exercises/actions'

export default {
  vuex: {
    getters: {
      allExercises
    },
    actions: {
      getAllExercises
    }
  },
  data () {
    return {
      filter: null
    }
  },
  computed: {
    filters () {
      const filters = new Map()

      this.allExercises.map((session) => {
        session.filters.forEach((filter) => {
          filters.set(filter, filter)
        })
      })
      return Array.from(filters)
    },
    sortedExercises () {
      return this.allExercises.concat().sort((a, b) => {
        if (a.title < b.title) return -1
        if (a.title > b.title) return 1
        return 0
      })
    },
    filteredExercises () {
      if (!this.filter) return this.sortedExercises
      return this.sortedExercises.filter(exercise => exercise.filters.indexOf(this.filter) > -1)
    }
  },
  methods: {
    setFilter (filter) {
      this.filter = filter
    }
  },
  ready () {
    this.getAllExercises()
  }
}



// WEBPACK FOOTER //
// ./src/mixins/exercises.js